import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { CatalogCreate, CatalogDeleteModal, CatalogHeader, CatalogList, CatalogUpdate } from '@app/features/Catalog';
import { useResourceScreenHelpers } from '@app/hooks';
import { catalogApi } from '@app/store';
import { ICatalog } from '@app/common';
import { CatalogPublishModal, CatalogPublishModalId } from '@app/features/Catalog/CatalogPublishModal';
import { useModal } from '@app/hooks/useModal';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const CatalogScreen = () => {
  const modal = useModal(CatalogPublishModalId);

  const [readOne, { isFetching }] = catalogApi.useLazyReadOneCatalogWithRelationsQuery();
  const [deleteOne, { isLoading }] = catalogApi.useDeleteOneCatalogsMutation();

  const { triptych, modal: deleteModal, onDelete, onUpdate, mode, selectedItem, item: catalog } = useResourceScreenHelpers<ICatalog>();

  const openCard = (item: Partial<ICatalog>) => {
    onUpdate(readOne(item?._id!), item);
  }

  return (
    <MainLayout
      header={(
        <CatalogHeader>
          <CheckPermissions permissions={['dashboard::catalogs.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un catalogue' />
          </CheckPermissions>
        </CatalogHeader>
      )}>

      <CatalogPublishModal {...modal} />

      <CatalogDeleteModal
        {...deleteModal}
        onDelete={(catalog) => onDelete(deleteOne(catalog._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <CatalogList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onPublish={(catalog) => modal.open(catalog)}
            onUpdate={openCard}
            onDelete={deleteModal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <CatalogCreate />
            : <CatalogUpdate
              catalog={catalog ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={deleteModal.open} />
        )} />
    </MainLayout>
  );
};

